import { render, staticRenderFns } from "./SectionConfigForm.vue?vue&type=template&id=47f2e0d2"
import script from "./SectionConfigForm.vue?vue&type=script&lang=js"
export * from "./SectionConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports